angular.module('invoice')
    .component('invoiceList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/invoice/list.html',
        controller: function ($scope, $state, $httpParamSerializer, $stateParams, User, Invoice, Principal, InvoiceService, InvoiceBgt, Currency, PaymentMethod, $document, $timeout, $filter, InvoiceConst, TableSelection, $transitions) {
            this.reset = () => this.filters = {filter: this.filters.filter}
            this.InvoiceService = InvoiceService
            this.costsEnabled = false
            this.settlementsEnabled = false
            this.bgtEnabled = false
            this.additionalInfoEnabled = false
            this.buyerAndPaymentEnabled = true
            this.shortAcceptanceGuideAvailable = false

            this.flags = [1, 2, 3, 4]
            this.summaryLoading = false
            this.summaryHidden = false

            const onSummaryLoadStart = $transitions.onBefore({}, transition => {
                if (transition.from() === transition.to()) {
                    this.summaryLoading = true
                } else {
                    this.summaryHidden = true
                }
            })
            const finishSummaryLoading = () => {
                this.summaryLoading = false
                this.summaryHidden = false
            }
            const onSummaryLoadFinish = $transitions.onFinish({}, finishSummaryLoading)
            const onSummaryLoadError = $transitions.onError({}, finishSummaryLoading)

            this.$onInit = () => {
                this.selection = TableSelection.create(this.page.list, selected => {
                    this.statistics.selected = InvoiceService.sumInvoicesByCurrency(selected)
                })
                this.currentTime = new Date()
                this.canReadInvoiceBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_BGT_READ', 'ROLE_INVOICE_DOCUMENTS_BGT_WRITE_WITH_READ_ACCESS', 'ROLE_ADMIN'])
                this.canExportInvoiceBgt = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_EXPORT']) && this.canReadInvoiceBgt
                InvoiceService.workflow.load().then(configuration => {
                    this.costsEnabled = configuration.costs && configuration.costs.enabled === true
                    this.settlementsEnabled = configuration.settlements && configuration.settlements.enabled === true
                    this.bgtEnabled = configuration.bgt && configuration.bgt.enabled === true
                    this.additionalInfoEnabled = configuration.additionalInfo && configuration.additionalInfo.enabled === true
                    this.buyerAndPaymentEnabled = configuration.listBuyerAndPaymentEnabled !== false
                    this.shortAcceptanceGuideAvailable = configuration.variant === 'SHORT_ACCEPTANCE'
                    return this.loadBgtSummary()
                })
                Invoice.types().$promise.then(items => this.types = items)
                Currency.list().$promise.then(items => items.map(c => c.symbol)).then(items => this.currencies = items)
                PaymentMethod.query().$promise.then(items => this.paymentMethods = items.map(it => ({id: it.id, name: $filter('localized')(it.name)})));
                Principal.currentUser().then(user => {
                    this.currentUserId = user.id
                    this.isAdmin = Principal.hasAnyAuthority(['ROLE_ADMIN'])
                    this.canReadKSEF = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_KSEF_REGISTRY', 'ROLE_INVOICE_DOCUMENTS_KSEF_SETTINGS'])
                    this.canDeleteInvoicesByRole = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING', 'ROLE_INVOICE_DOCUMENTS_ALL'])
                    this.canDeleteConfidentialInvoices = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_CONFIDENTIAL'])
                })
            }

            this.loadBgtSummary = () => {
                if (!this.bgtEnabled || !this.canReadInvoiceBgt || !this.page || !angular.isArray(this.page.list) || !this.page.list.length) {
                    return
                }

                let invoiceIds = this.page.list.map(item => item.id).filter(id => id != null);
                if (!invoiceIds.length) {
                    return
                }

                return InvoiceBgt.summary({}, {invoiceIds: invoiceIds}).$promise.then(summaries => {
                    this.page.list.forEach(item => {
                        item.bgtSummary = summaries[item.id] || {totalNet: 0};
                    })
                })
            }

            this.getBgtTotalNet = item => {
                return this.toMoneyNumber(item && item.bgtSummary && item.bgtSummary.totalNet);
            }

            this.getInvoiceTotalNet = item => {
                return this.toMoneyNumber(item && item.pricing && item.pricing.totalNet);
            }

            this.toMoneyNumber = value => {
                return InvoiceService.round(value || 0);
            }

            this.hasBgtSummary = item => {
                return item && item.bgtSummary != null;
            }

            this.hasBgtMismatch = item => {
                if (!this.hasBgtSummary(item)) {
                    return false;
                }
                let bgtTotalNet = this.getBgtTotalNet(item);
                return bgtTotalNet > 0 && bgtTotalNet !== this.getInvoiceTotalNet(item);
            }

            this.hasEmptyBgt = item => {
                if (!this.hasBgtSummary(item)) {
                    return false;
                }
                return this.getBgtTotalNet(item) === 0 && this.getInvoiceTotalNet(item) !== 0;
            }

            this.getBgtDifference = item => {
                return InvoiceService.sub(this.getBgtTotalNet(item), this.getInvoiceTotalNet(item));
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-batch/export?" + $httpParamSerializer(paramsAll)
            }
            this.getExportWithCostsUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-batch/export-with-costs?" + $httpParamSerializer(paramsAll)
            }
            this.getExportWithBgtUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-batch/export-with-bgt?" + $httpParamSerializer(paramsAll)
            }
            this.getExportWithCostsBgtSummaryUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-batch/export-with-costs-bgt-summary?" + $httpParamSerializer(paramsAll)
            }

            this.getPdfZipExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-batch-pdf-zip/export?" + $httpParamSerializer(paramsAll)
            }
            this.getKsefXmlZipExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-batch-pdf-zip/export-ksef-xml?" + $httpParamSerializer(paramsAll)
            }

            let ksefPopoverClosePromise = null
            const getKsefListItems = () => (this.page && this.page.list) || []
            const closeAllKsefPopovers = exceptItem => {
                const items = getKsefListItems()
                items.forEach(listItem => {
                    if (listItem === exceptItem) {
                        return
                    }
                    listItem._isKsefPopoverOpen = false
                    listItem._ksefPopoverPinned = false
                    listItem._ksefPopoverTriggerHover = false
                    listItem._ksefPopoverContentHover = false
                })
            }
            const shouldKeepKsefPopoverOpen = item => !!(item && (item._ksefPopoverPinned || item._ksefPopoverTriggerHover || item._ksefPopoverContentHover))

            this.onKsefPopoverTriggerEnter = item => {
                if (!item) {
                    return
                }
                this.cancelKsefPopoverClose()
                const pinnedItem = getKsefListItems().find(listItem => listItem._ksefPopoverPinned)
                if (pinnedItem && pinnedItem !== item) {
                    return
                }
                item._ksefPopoverTriggerHover = true
                closeAllKsefPopovers(item)
                item._isKsefPopoverOpen = true
            }
            this.onKsefPopoverTriggerLeave = item => {
                if (!item) {
                    return
                }
                item._ksefPopoverTriggerHover = false
                this.scheduleKsefPopoverClose(item)
            }
            this.onKsefPopoverContentEnter = item => {
                if (!item) {
                    return
                }
                this.cancelKsefPopoverClose()
                item._ksefPopoverContentHover = true
                item._isKsefPopoverOpen = true
            }
            this.onKsefPopoverContentLeave = item => {
                if (!item) {
                    return
                }
                item._ksefPopoverContentHover = false
                this.scheduleKsefPopoverClose(item)
            }
            this.pinKsefPopover = (item, $event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                if (!item) {
                    return
                }
                this.cancelKsefPopoverClose()
                closeAllKsefPopovers(item)
                item._ksefPopoverPinned = true
                item._ksefPopoverTriggerHover = true
                item._isKsefPopoverOpen = true
            }
            this.scheduleKsefPopoverClose = item => {
                if (!item) {
                    return
                }
                this.cancelKsefPopoverClose()
                ksefPopoverClosePromise = $timeout(() => {
                    if (shouldKeepKsefPopoverOpen(item)) {
                        return
                    }
                    item._isKsefPopoverOpen = false
                }, 220)
            }
            this.cancelKsefPopoverClose = () => {
                if (!ksefPopoverClosePromise) {
                    return
                }
                $timeout.cancel(ksefPopoverClosePromise)
                ksefPopoverClosePromise = null
            }

            const isClickInsideKsefPopover = rawTarget => {
                if (!rawTarget) {
                    return false
                }
                const target = rawTarget.nodeType === 3 ? rawTarget.parentElement : rawTarget
                if (!target || !target.closest) {
                    return false
                }
                return !!(target.closest('.ksef-export-popover-wrapper') || target.closest('.ksef-export-popover-trigger'))
            }

            const onDocumentClick = event => {
                if (event && event.defaultPrevented) {
                    return
                }
                if (isClickInsideKsefPopover(event && event.target)) {
                    return
                }
                $scope.$applyAsync(() => {
                    this.cancelKsefPopoverClose()
                    closeAllKsefPopovers()
                })
            }

            $document.on('click', onDocumentClick)
            $scope.$on('$destroy', () => {
                this.cancelKsefPopoverClose()
                $document.off('click', onDocumentClick)
                onSummaryLoadStart()
                onSummaryLoadFinish()
                onSummaryLoadError()
            })

            this.passSelected = () => {
                return InvoiceService.passMany(this.selection.selected).then(() => $state.reload())
            }

            this.canDeleteSelected = () => {
                const configuration = InvoiceService.workflow.configuration
                if (!this.selection.hasSelected() || !configuration || !configuration.initialStatus) {
                    return false
                }
                const canDeleteFromConfidentialList = this.canDeleteConfidentialInvoices && this.filters && this.filters.filter === 'confidential'
                return this.selection.selected.every(item => item.status === configuration.initialStatus && (this.canDeleteInvoicesByRole || canDeleteFromConfidentialList || (item.worker && item.worker.id === this.currentUserId && !item.ksef)))
            }

            this.deleteSelected = () => {
                if (!this.canDeleteSelected()) {
                    return
                }
                return InvoiceService.removeMany(this.selection.selected)
            }

            this.hasSelectedKsef = () => {
                return !!this.selection.selected.find(item => item && item.ksef && item.ksef.ksefNumber)
            }

            this.resetKsefExportSelected = () => {
                if (!this.selection.hasSelected()) {
                    return
                }
                const ids = this.selection.selected
                    .filter(item => item && item.ksef && item.ksef.ksefNumber)
                    .map(item => item.id)
                    .filter(id => id != null)
                if (ids.length === 0) {
                    return
                }
                return InvoiceService.resetKsefXmlExport(ids)
            }

            this.searchFieldPopover = `
                <div>Prefiksy:</div>
                <div><b>df*</b> - nr dokumentu</div>
                <div><b>info*</b> - informacja dodatkowa</div>
                <div><b>fvz*</b> - nr dok. księg.</div>
                <div><b>spr*</b> - sprzedawca (symbol, nazwa, nip)</div>
                <div><b>nab*</b> - nabywca (symbol, nazwa, nip)</div>
                <div><b>net*</b> - wartość netto od__do</div>
                <div><b>vat*</b> - wartość VAT od__do</div>
                <div><b>bru*</b> - wartość brutto od__do</div>
                <div><b>bezpdf*</b> - bez głównego pliku PDF</div>
                <div><b>przydzielone*</b> - ile dni od dzisiaj przydzielone do pracownika</div>
                <div><b>ref*</b> - do refaktury</div>
                <div><b>terminPlatnosciError*</b> - błędny termin płatności</div>
                <div><b>ksef*</b> - tylko ksef</div>
                <div><b>bgtNiezgodne*</b> - suma BGT różna od netto DF przy niezerowym netto DF</div>
                <div><b>bgtZero*</b> - BGT = 0 przy niezerowym netto DF</div>
            `

            $scope.$on(InvoiceConst.eventUpdate, () => $state.reload())
        }
    })
